import {
	getAction
} from '@/api/index';
import {
	mapGetters
} from 'vuex'
export default {
	data() {
		return {
			url: {
				homeSetting: '/officialWebsite/c-api/setting/home',
				homeProductCatSetting: '/officialWebsite/c-api/setting/home/productCat',
				subBrandSetting: '/officialWebsite/c-api/setting/subBrand'
			},
			settingData: {},
			subBrandSettingData: '',
			swiper: {
				flag: true, // 用来节流防止重复点击
				offset: 0, //轮播图盒子的偏移值
				ition: 0.8, //设置轮播图过渡时间
				imgShow: 0, //表示当前显示的图片索引
				timeOut: null, //定时器
				progressItion: [] ,//竖屏视频海报进度动画时长记录
				touchStartX: 0, //鼠标按下/拖动开始位置
			},
			productCatLst: [],
			productCatIdx: 0,
			isLoaded: false
		}
	},
	computed: {
		...mapGetters(["scaleRate","isVerticalScreen"]),
		mediaLength() {
			if(this.settingData && this.settingData.mediaLst) {
				return this.settingData.mediaLst.length;
			}
			return 0;
		},
		curProductCat() {
			return this.productCatLst[this.productCatIdx];
		}
	},
	mounted() {
		this.loadData();
	},
	activated() {
		if(this.settingData && this.settingData.mediaLst 
			&& this.settingData.mediaLst.length > 0
			&& (
				(this.settingData.mediaLst[this.swiper.imgShow].videoUrl && !this.isVerticalScreen)
				|| (this.settingData.mediaLst[this.swiper.imgShow].videoUrlV && this.isVerticalScreen)
			)) {
			let videoDom = document.getElementById('poster-video-player' + this.swiper.imgShow);
			if(videoDom && videoDom.paused) videoDom.play();
		}
	},
	methods: {
		loadData() {
			this.loadSetting();
			this.loadSubBrandSetting();
			this.loadProductCatSetting();
		},
		async loadSetting() {
			const res = await getAction(this.url.homeSetting);
			if (res.success) {
				this.settingData = res.result;
				this.$nextTick(() => {
					this.autoRun();
				});
			}
		},
		async loadSubBrandSetting() {
			const res = await getAction(this.url.subBrandSetting);
			if (res.success) {
				this.subBrandSettingData = res.result;
				this.calcContentHeight();
			}
		},
		calcContentHeight() {
			this.$nextTick(() => {
				let doms = document.getElementsByClassName('auto-height');
				for (let i = 0; i < doms.length; i++) {
					doms[i].style.height =
						(doms[i].getElementsByClassName('calc-line')[0].getBoundingClientRect().height) + 'px';
				}
			});
		},
		async loadProductCatSetting() {
			const res = await getAction(this.url.homeProductCatSetting);
			if (res.success) {
				this.productCatLst = res.result;
				this.$nextTick(() => {
					if(this.onProductCatLoaded) this.onProductCatLoaded();
					this.isLoaded = true;
				});
			}
		},
		onclickMenuClick(idx) {
			if((!this.isVerticalScreen && this.settingData.mediaLst[this.swiper.imgShow].videoUrl) 
				|| (this.isVerticalScreen && this.settingData.mediaLst[this.swiper.imgShow].videoUrlV)) {
				let videoDom = document.getElementById('poster-video-player' + this.swiper.imgShow);
				if(videoDom) {
					videoDom.pause();
					this.unloadProgressAni(this.swiper.imgShow);
				}
			}
			this.throttle(this.changeFun, idx);
			//this.autoRun();
		},
		onloadedmetadata(idx) {
			this.$set(this.settingData.mediaLst[idx], 'loaded', true);
		},
		onVideoEnded(idx) {
			this.unloadProgressAni(idx);
			this.throttle(this.nextFun);
			//this.autoRun();
		},
		onVideoLoaded(idx) {
			let videoDom = document.getElementById('poster-video-player' + idx);
			if(videoDom) {
				this.$set(this.swiper.progressItion, idx, videoDom.duration);
				this.loadProgressAni(idx);
			}
		},
		//装载进度动画
		loadProgressAni(idx) {
			const doms = document.querySelectorAll('.rotation-poster .swiper-wrapper .swiper-item .progress');
			if(doms && doms.length >= idx + 1) {
				doms[idx].style.transition = 'width '
					+this.swiper.progressItion[idx]+'s ease-in-out';
			}
		},
		unloadProgressAni(idx) {
			const doms = document.querySelectorAll('.rotation-poster .swiper-wrapper .swiper-item .progress');
			if(doms && doms.length >= idx + 1) {
				doms[idx].style.transition = null;
			}
		},
		autoRun() {
			if(this.swiper.timeOut) {
				clearTimeout(this.swiper.timeOut)
			}
			if((!this.isVerticalScreen && this.settingData.mediaLst[this.swiper.imgShow].videoUrl) 
				|| (this.isVerticalScreen && this.settingData.mediaLst[this.swiper.imgShow].videoUrlV)) {
				let videoDom = document.getElementById('poster-video-player' + this.swiper.imgShow);
				if(videoDom) {
					if(this.swiper.progressItion[this.swiper.imgShow]) {
						this.loadProgressAni(this.swiper.imgShow);
					}
					videoDom.currentTime = 0;
					videoDom.play();
				}
				return;
			}
			this.swiper.timeOut = setTimeout(() => {
				this.throttle(this.nextFun);
				//this.autoRun();
			}, 4000)
		},
		// 这里通过额外封装的节流函数触发 PrevFun() 和 NextFun(),以达到防止重复点击的效果
		throttle(fun, param) {
			if (this.swiper.flag) {
				this.swiper.flag = false;
				fun(param);
				setTimeout(() => {
					this.swiper.flag = true;
					this.autoRun();
				}, 500)
			}
		},
		changeFun(imgShow) {
			this.swiper.imgShow = imgShow;
			this.swiper.offset = '-' + (this.swiper.imgShow * 100) + '%';
		},
		prevFun() {
			if (this.swiper.imgShow != 0) {
				// 判断显示的图片 不是 第一张时执行
				this.swiper.imgShow--;
			} else {
				this.swiper.imgShow = this.mediaLength - 1;
			}
			this.swiper.offset = '-' + (this.swiper.imgShow * 100) + '%';
		},
		nextFun() {
			if (this.swiper.imgShow < this.mediaLength - 1) {
				// 判断显示的图片 不是 最后一张时执行
				this.swiper.imgShow++;
			} else {
				this.swiper.imgShow = 0;
			}
			this.swiper.offset = '-' + (this.swiper.imgShow * 100) + '%';
		},
		onProductItemClick(id) {
			this.$router.push({
				path: '/detail?type=product&id=' + id
			});
		},
		onPosterClick(item) {
			if(item.linkUrl) {
				const id = 'url_poster'+item.sortNo;
				var a = document.createElement('a');
				a.setAttribute('href', item.linkUrl);
				a.setAttribute('target', '_blank');
				a.setAttribute('id', id);
				// 防止反复添加
				if(!document.getElementById(id)) document.body.appendChild(a);
				a.click();
				document.getElementById(id).remove();
			}
			
		}
	}
}